import { withInstall } from '@lit-element/utils'
import InputNumber from './src/input-number.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtInputNumber: SFCWithInstall<typeof InputNumber> =
  withInstall(InputNumber)

export default LtInputNumber
export * from './src/input-number'
